export default __webpack_public_path__ + "locales/ko-KR/PrivacyPage.json?hash=3063474a69869188b12ae147a372246e";